export const COUNTRY_CODE_COOKIE = 'omniCoutryCode';
export const CART_ID_COOKIE = 'eCommCartId';
export const CART_ZONE_COOKIE = 'eCartZone';

export const VALIDATION_ERROR_CODES = {
  REQUIRED: 'required',
  MIN: 'min',
  MAX: 'max',
};

export const PRODUCT_TYPES = {
  TRAINING_VOUCHERS: 'trainingvouchers',
};
